module.exports = __webpack_public_path__ + "static/devpro-logo-78922674b5afe8f946a6f05b24eeaa86.png";